<template>
  <div class="so-message">
    <base-heading>{{ $t('standingOrder.createOrderTitle') }}</base-heading>
    <div class="message-wrapper">
      <h3 class="title">{{ $t('standingOrder.noOrders.title') }}</h3>
      <p class="description">{{ $t('standingOrder.noOrders.description') }}</p>
      <base-button variant="primary" @click="emitCreateNewAccount">{{ $t('standingOrder.noOrders.addOrderLabel') }}</base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'so-no-orders',
  methods: {
    emitCreateNewAccount () {
      this.$emit('add-new-order')
    }
  }
}
</script>

<style scoped lang="scss" src="./styles/so-comps-common.scss"></style>
